const setFlex = ({ justify, align, direction }) => `
  display: flex;
  ${justify ? `justify-content: ${justify}` : ""};
  ${align ? `align-items: ${align}` : ""};
  ${direction ? `flex-direction: ${direction}` : ""};
`;

const setPosition = ({ position, top, bottom, left, right, zIndex }) => `
  ${position ? `position: ${position}` : ""};
  ${top ? `top: ${top}px` : ""};
  ${bottom ? `bottom: ${bottom}px` : ""};
  ${left ? `left: ${left}px` : ""};
  ${right ? `right: ${right}px` : ""};
  ${zIndex ? `z-index: ${zIndex}` : ""};
`;

const preventDrag = () => `
user-drag: none;
user-select: none;
-webkit-user-drag: none;
-webkit-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
`;

const generateMediaQueries = breakpoints => {
  const queryParts = Object.keys(breakpoints).map(key => {
    const bp = breakpoints[key];
    return `screen and (device-width: ${bp.width}px) and (device-height: ${bp.height}px)`;
  });
  return `@media ${queryParts.join(", ")}`;
};

export { setFlex, setPosition, preventDrag, generateMediaQueries };

// Example usage:
// ${setFlex({ justify: "flex-start", align: "center", direction: "column" })};
// ${setPosition({ position: "relative", top: "0" })};
